/**
 * Concordância de número nas mensagens da tela.
 *
 * Existe para não escrever "1 aula(s) removida(s)": o sistema fala com secretaria e direção, e
 * texto com parênteses de plural passa impressão de rascunho.
 */

/** "1 aula" / "3 aulas" — o número entra junto. */
export function pluralizar(quantidade: number, singular: string, plural: string): string {
  return `${quantidade} ${quantidade === 1 ? singular : plural}`;
}

/** Só a palavra concordada, sem o número. Útil quando o número já apareceu na frase. */
export function concordar(quantidade: number, singular: string, plural: string): string {
  return quantidade === 1 ? singular : plural;
}

/**
 * Tira a marca "(NOVO)" da descrição de um item de menu, para EXIBIR ao usuário.
 *
 * A marca existe na Seg_Menu para separar, na tela de permissões dos grupos, a permissão da tela
 * nova da do legado — lá ela tem de continuar aparecendo. No menu lateral ela só polui o nome.
 * Só sai "(NOVO)" exatamente assim — maiúsculo e entre parênteses; "(Novo)" e qualquer outra
 * variação continuam aparecendo. O resto do texto fica como está.
 */
export function removerMarcaNovo(descricao: string): string {
  return String(descricao ?? '')
    .replace(/\(NOVO\)/g, ' ')
    .replace(/\s{2,}/g, ' ')
    .trim();
}
